<template>
  <div>
    <position-context-watch-settings-dialog
      v-if="isPositionGroup"
      :visible="visible"
      @update:visible="$emit('update:visible', $event)"
      @saved="$emit('saved', $event)"
    />
    <notification-task-settings-preview-dialog
      v-else
      :visible="visible"
      :group="group"
      @update:visible="$emit('update:visible', $event)"
      @saved="$emit('saved', $event)"
    />
  </div>
</template>

<script>
import NotificationTaskSettingsPreviewDialog from '@/components/NotificationTaskSettingsPreviewDialog.vue'
import PositionContextWatchSettingsDialog from '@/components/PositionContextWatchSettingsDialog.vue'

export default {
  name: 'NotificationTaskSettingsRouterDialog',
  components: {
    NotificationTaskSettingsPreviewDialog,
    PositionContextWatchSettingsDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    group: {
      type: Object,
      default: null
    }
  },
  computed: {
    isPositionGroup() {
      return Boolean(this.group && this.group.groupId === 'position_context_watch')
    }
  }
}
</script>
